/* DHC v1053.27 B101 — coded style swatches + Shopify-safe Style & Set + US size display */
(function(){
  'use strict';
  var COLOR_WORDS=/^(black|white|red|blue|green|yellow|orange|purple|pink|brown|gray|grey|gold|golden|silver|beige|tan|navy|teal|maroon|burgundy|ivory|cream|khaki|multicolor|multi|transparent|clear|rose|violet|lavender|aqua|cyan|magenta)(\b|\s|\/|\-|\+)/i;
  var SET_WORDS=/(costume|wig|accessor|\b\d+\s*pcs\b|piece|outfit|suit|dress|\bset\b|bundle|pack|jacket|coat|mask|glove|weapon|prop)/i;

  function money(cents){
    try{ if(window.Shopify && typeof Shopify.formatMoney==='function') return Shopify.formatMoney(cents); }catch(e){}
    return '$'+(Number(cents||0)/100).toFixed(2);
  }
  function shortOpaqueCode(v){
    v=String(v||'').trim();
    if(!v || v.length>16 || COLOR_WORDS.test(v) || SET_WORDS.test(v)) return false;
    return /^[A-Za-z0-9][A-Za-z0-9 _+./-]{0,15}$/.test(v);
  }
  function visibleLabel(input){
    var label=input.closest('label');
    if(!label) return null;
    var wrap=label.querySelector('.dhc-pdp-v1053-22__option-label');
    if(wrap){
      var spans=wrap.querySelectorAll(':scope > span');
      return spans.length ? spans[0] : wrap;
    }
    return label.querySelector('span') || label;
  }
  function cleanCmSize(raw){
    var s=String(raw||'').trim();
    var m=s.match(/(?:size\s*\d+\s*)?\(?\s*(\d{2,3}(?:\.\d+)?)\s*[-–]\s*(\d{2,3}(?:\.\d+)?)\s*cm\s*\)?/i);
    var a,b;
    if(m){
      a=Number(m[1]); b=Number(m[2]);
    }else{
      var single=s.match(/^(?:size\s*)?(\d{2,3}(?:\.\d+)?)\s*cm$/i);
      if(!single) return null;
      b=Number(single[1]);
      if(!(b>=70 && b<=220)) return null;
      a=b-10;
    }
    if(!(a>0 && b>a)) return null;
    var ia=Math.round(a/2.54), ib=Math.round(b/2.54);
    return ia+'–'+ib+' in';
  }
  function firstVariantInfo(variantSelect, groupIndex, value){
    var found=null;
    [].slice.call(variantSelect.options).some(function(opt){
      if(opt.disabled) return false;
      try{
        var opts=JSON.parse(opt.getAttribute('data-options')||'[]');
        if(String(opts[groupIndex])===String(value)){
          found={
            price:Number(opt.getAttribute('data-price')||0),
            mediaUrl:String(opt.getAttribute('data-media-url')||'')
          };
          return true;
        }
      }catch(e){}
      return false;
    });
    return found;
  }
  function boot(root){
    (root||document).querySelectorAll('.dhc-pdp-v931').forEach(function(pdp){
      if(pdp.dataset.dhcB98Clarity==='1') return;
      pdp.dataset.dhcB98Clarity='1';
      var variantSelect=pdp.querySelector('[data-dhc-variant-select]');
      if(!variantSelect) return;
      var groups=[].slice.call(pdp.querySelectorAll('.dhc-pdp__option-group'));

      groups.forEach(function(group,groupIndex){
        var legend=group.querySelector('legend');
        var inputs=[].slice.call(group.querySelectorAll('input[data-dhc-option]'));
        if(!legend || !inputs.length) return;
        var values=inputs.map(function(i){return String(i.value||'').trim();});
        var joined=values.join(' | ');
        var isColor=/^colou?r\s*:?$/i.test(String(legend.textContent||'').trim());
        var semantic=SET_WORDS.test(joined);
        var opaqueCodes=values.length>1 && values.every(shortOpaqueCode);
        var isStyleSet=isColor && (semantic || opaqueCodes);

        if(isStyleSet){
          legend.textContent='Style & Set';
          group.classList.add('dhc-pdp-v1053-24__style-set');
          if(!group.querySelector('[data-dhc-b98-help]')){
            var help=document.createElement('p');
            help.className='dhc-pdp-v1037__option-help';
            help.setAttribute('data-dhc-b98-help','');
            help.innerHTML=opaqueCodes
              ? '<strong>Choose the set shown in the picture.</strong> These supplier style codes represent different product configurations. Your selected picture, price and size determine what you receive.'
              : '<strong>Choose what you want to receive.</strong> Different sets can include different pieces and prices. Choose a Style & Set, then your size.';
            var pills=group.querySelector('.dhc-pdp__option-pills');
            group.insertBefore(help,pills||null);
          }

          inputs.forEach(function(input){
            var prices=[], mediaUrl='';
            [].slice.call(variantSelect.options).forEach(function(opt){
              if(opt.disabled) return;
              try{
                var opts=JSON.parse(opt.getAttribute('data-options')||'[]');
                if(String(opts[groupIndex])===String(input.value)){
                  var p=Number(opt.getAttribute('data-price')||0); if(p>0) prices.push(p);
                  if(!mediaUrl) mediaUrl=String(opt.getAttribute('data-media-url')||'');
                }
              }catch(e){}
            });
            prices.sort(function(a,b){return a-b});
            var label=input.closest('label');
            var wrap=label && (label.querySelector('.dhc-pdp-v1053-22__option-label') || label);
            if(!wrap) return;
            if(mediaUrl && !label.querySelector('[data-dhc-b98-swatch]') && !label.querySelector('[data-dhc-b101-swatch]')){
              var img=document.createElement('img');
              img.src=mediaUrl;
              img.alt='';
              img.loading='lazy';
              img.width=52; img.height=52;
              img.setAttribute('data-dhc-b98-swatch','');
              img.style.cssText='width:52px;height:52px;object-fit:cover;border-radius:8px;display:block;margin:0 auto 6px;';
              wrap.insertBefore(img,wrap.firstChild);
            }
            if(prices.length && !label.querySelector('[data-dhc-b98-price]') && !label.querySelector('[data-dhc-b97-price]')){
              var small=document.createElement('small');
              small.setAttribute('data-dhc-b98-price','');
              small.textContent=(prices[prices.length-1]>prices[0]?'From ':'')+money(prices[0]);
              wrap.appendChild(small);
            }
          });
        }

        var isSize=/size/i.test(String(legend.textContent||''));
        if(isSize){
          inputs.forEach(function(input){
            var cleaned=cleanCmSize(input.value);
            if(!cleaned) return;
            var target=visibleLabel(input);
            if(target){
              target.textContent=cleaned;
              target.setAttribute('title',String(input.value||''));
            }
          });
          if(!group.querySelector('[data-dhc-b98-size-help]')){
            var anyClean=inputs.some(function(i){return !!cleanCmSize(i.value)});
            if(anyClean){
              var note=document.createElement('p');
              note.className='dhc-pdp-v1037__option-help';
              note.setAttribute('data-dhc-b98-size-help','');
              note.textContent='Sizes converted from the supplier’s centimeter range to approximate inches.';
              var pills2=group.querySelector('.dhc-pdp__option-pills');
              group.insertBefore(note,pills2||null);
            }
          }
        }
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true}); else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
